<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-md-12">
        <h1>Keystrokes APP</h1>
        </div>
      </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Roboto Mono", "Roboto Mono", "Vazirmatn";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}
body {
  background-color: #323437;
  color: #14e27b;
  font-family: "Roboto Mono", "Roboto Mono", "Vazirmatn";
}
</style>



// WEBPACK FOOTER //
// src/App.vue